import { IPart, PartStatus } from "../../../models/Part";
import StatusPill, { StatusPillColour } from "../../shared/StatusPill";

const statusColour = (status: PartStatus | null | undefined): StatusPillColour => {
  switch (status) {
    case PartStatus["On The Car"]:
      return StatusPillColour.Orange;
    case PartStatus["Pending Dismantle"]:
      return StatusPillColour.Yellow;
    case PartStatus.Dismantled:
      return StatusPillColour.Green;
    case PartStatus.Damaged:
      return StatusPillColour.Red;
    case PartStatus.QC:
      return StatusPillColour.Purple;
    case PartStatus.Missing:
      return StatusPillColour.Yellow;
    case PartStatus.Sold:
      return StatusPillColour.Blue;
    case PartStatus.Returned:
      return StatusPillColour.Red;
    case PartStatus.Deleted:
    default:
      return StatusPillColour.Neutral;
  }
};

export default function StockStatusPill({ part }: { part: IPart }) {
  if (part.partStatus === null || part.partStatus === undefined) {
    return <StatusPill text="N/A" colour={StatusPillColour.Neutral} />;
  }
  return (
    <StatusPill
      text={PartStatus[part.partStatus]}
      colour={statusColour(part.partStatus)}
    />
  );
}
